import React from 'react';
import ProductSidebarComponent from './ProductSidebarComponent';
import { PageHeader } from '../../components';

const MunicipalWtpStpCetps: React.FC = () => {
  return (
    <>
      <PageHeader title="Municipal WTP/STP/CETPs – Operation & Maintenance" breadcrumbs={[{ label: "Products", path: "/products" }]} />

      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s"
        style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
        <div className="container">
          <div className="row g-5">

            <div className="col-lg-8">
              <div className="row g-3 mb-5">
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-3.jpg" alt="" />
                </div>
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-1.jpg" alt="" />
                </div>
              </div>
              <h1 className="mb-4">Municipal WTP/STP/CETPs – Operation & Maintenance</h1>
              
              <h3 className="mb-4">Overview</h3>
              <p>Managing municipal water and wastewater infrastructure requires deep expertise, round-the-clock commitment, and strict compliance with government norms. At Wasser Technochem (India) Ltd., we provide end-to-end Operation & Maintenance (O&M) services for Water Treatment Plants (WTPs), Sewage Treatment Plants (STPs), and Common Effluent Treatment Plants (CETPs) operated by ULBs, smart cities, industrial clusters, and development authorities.</p>
              <p>With decades of experience in municipal operations and our legacy of pioneering O&M services, we ensure maximum system uptime, regulatory compliance, and cost-effective operations.</p>

              <h3 className="mb-4">Scope of Services</h3>
              <div className="row g-4 mb-4">
                <div className="col-md-6">
                  <p><i className="fa fa-cogs text-primary me-2"></i>Daily operations, monitoring, and recordkeeping</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-wrench text-primary me-2"></i>Preventive and breakdown maintenance</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-flask text-primary me-2"></i>Chemical handling and dosing</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-microchip text-primary me-2"></i>SCADA and automation system management</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-chart-line text-primary me-2"></i>Flow, pH, TSS, BOD/COD monitoring</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-recycle text-primary me-2"></i>Sludge and waste handling</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-exclamation-triangle text-primary me-2"></i>Emergency response management</p>
                </div>
                <div className="col-md-6">
                  <p><i className="fa fa-leaf text-primary me-2"></i>Asset life extension and energy optimization</p>
                </div>
              </div>

              <h3 className="mb-4">Coverage</h3>
              <div className="row g-4 mb-4">
                <div className="col-md-6">
                  <div className="service-item">
                    <div className="overflow-hidden">
                      <h5><i className="fa fa-tint text-primary me-2"></i>Urban WTPs</h5>
                      <p>Urban water supply and distribution WTPs</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="service-item">
                    <div className="overflow-hidden">
                      <h5><i className="fa fa-industry text-primary me-2"></i>Municipal STPs</h5>
                      <p>Decentralized and centralized STPs (SBR/MBBR/MBBR + UV)</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="service-item">
                    <div className="overflow-hidden">
                      <h5><i className="fa fa-building text-primary me-2"></i>Industrial CETPs</h5>
                      <p>CETPs for textile, pharma, and chemical clusters</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="service-item">
                    <div className="overflow-hidden">
                      <h5><i className="fa fa-city text-primary me-2"></i>Mission Plants</h5>
                      <p>Plants under AMRUT, Namami Gange, and Smart City missions</p>
                    </div>
                  </div>
                </div>
              </div>

              <h3 className="mb-4">Benefits</h3>
              <div className="row g-4 mb-5">
                <div className="col-md-6">
                  <h5><i className="fa fa-check-circle text-success me-2"></i>Regulatory Compliance</h5>
                  <p>Compliance with NGT, SPCB, and CPCB norms</p>
                </div>
                <div className="col-md-6">
                  <h5><i className="fa fa-check-circle text-success me-2"></i>Improved Reliability</h5>
                  <p>Improved plant reliability and treated water quality</p>
                </div>
                <div className="col-md-6">
                  <h5><i className="fa fa-check-circle text-success me-2"></i>Reduced Downtime</h5>
                  <p>Reduced downtime and energy consumption</p>
                </div>
                <div className="col-md-6">
                  <h5><i className="fa fa-check-circle text-success me-2"></i>Skilled Operations</h5>
                  <p>Skilled, certified operators under WTIL's supervision</p>
                </div>
                <div className="col-md-12">
                  <h5><i className="fa fa-check-circle text-success me-2"></i>Digital Monitoring</h5>
                  <p>Digital monitoring and reporting (daily/monthly/yearly logs)</p>
                </div>
              </div>

              <h3 className="mb-4">Why WTIL?</h3>
              <div className="row g-4">
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-clock text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>Proven Experience</h5>
                      <p className="mb-0">Over 2 decades of O&M service delivery to urban and semi-urban utilities</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-expand-arrows-alt text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>Scalable Operations</h5>
                      <p className="mb-0">Operating capacities from 0.5 MLD to 50+ MLD</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-users text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>Expert Teams</h5>
                      <p className="mb-0">Teams trained in mechanical, electrical, instrumentation, and SCADA</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-medal text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>Mission Experience</h5>
                      <p className="mb-0">Experience with STPs under Namami Gange and Rajasthan Jal Swavlamban Yojana</p>
                    </div>
                  </div>
                </div>
                <div className="col-md-12">
                  <div className="d-flex">
                    <div className="flex-shrink-0 btn-square bg-primary rounded-circle" style={{ width: "64px", height: "64px" }}>
                      <i className="fa fa-globe text-white"></i>
                    </div>
                    <div className="ms-4">
                      <h5>Multi-Location Capability</h5>
                      <p className="mb-0">Ability to scale up with multi-location, multi-technology plants</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <ProductSidebarComponent />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default MunicipalWtpStpCetps;
